import React from 'react';
import { menuIcon } from '@chordbaker/design';

interface MenuIconProps {
  className?: string;
}

const MenuIcon: React.FC<MenuIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={menuIcon.viewBox}
      fill={menuIcon.fill}
      className={className}
    >
      <path d={(menuIcon.elements[0] as { d: string }).d} />
    </svg>
  );
};

export default MenuIcon;
